'use strict';

module.exports = function () {
  return global.location.protocol === 'http:';
};
